import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";

const statusOptions = [
    {value:true,label:"Активный"},
    {value:false,label:"Неактивный"},
]

const typeOptions = [
    {value:"common",label:"Обычный"},
    {value:"self-esteem",label:"Самоаудит"},
]

const SearchBlock = ({facilityOptions, auditOptions, handleFiltersData}) => {
    const [facility,setFacility]=useState(null);
    const [AuditStatus,setAuditStatus]=useState(null);
    const [AuditType,setAuditType]=useState(null);
    const [AuditName,setAuditName]=useState(null);

    // Функция применения фильтров
    const applyFilters = () => {
        handleFiltersData(facility, AuditStatus, AuditType, AuditName);
    };

    // Автоматический вызов при изменении любого фильтра
    useEffect(() => {
        applyFilters();
    }, [facility, AuditStatus, AuditType, AuditName]);

    return(
        <>
        <div className="row">
            <div className="col-md-6 d-flex justify-content-between gap-2 mb-1">
                <Select
                className="search-filter"
                options={facilityOptions} 
                placeholder="Завод"
                onChange={(e)=>{
                    setFacility(e?.value || null);
                }}
                isClearable/>
                <Select 
                className="search-filter"
                options={statusOptions} 
                placeholder="Статус" 
                onChange={(e)=>{
                    setAuditStatus(e?.value || null);
                }}
                isClearable/>
                <Select 
                className="search-filter"
                options={typeOptions} 
                placeholder="Тип" 
                onChange={(e)=>{
                    setAuditType(e?.value || null);
                }}
                isClearable/>
            </div>
            <div className="col-md-6">
            <Select 
            options={auditOptions} 
            placeholder="Поиск..." 
            onChange={(e)=>{
                setAuditName(e?.value || null)
            }}
            isClearable/>
            </div>
        </div>
        </>
    )
}

export default SearchBlock;